
import Vue from "vue";
import { BookYearService } from "@/services";
import { FixedAssetService, IManualOpeningGroup, IOpeningBalanceResult, IUpdateBookYearResult } from "@/services/fixed-asset-service";
import { printHumanFloat, printLocalDate } from "@/utils/pretty-print";

export default Vue.extend({
	data() {
		return {
			bookYear: BookYearService.selectedBookYear,
			status: null as IOpeningBalanceResult | null,
			result: null as IUpdateBookYearResult | null,
			doDepreciations: true,
			doOpeningBalance: true,
			busy: false
		};
	},
	computed: {
		hasPreviousBookYear():boolean {
			return BookYearService.bookYears.some(b => b.Year == this.bookYear - 1);
		},
		statusParams():any {
			if (!this.status) return {};
			return {
				date: this.status.LastOpeningBalanceDate ? printLocalDate(this.status.LastOpeningBalanceDate) : "",
				lines: this.status.Lines,
				debet: printHumanFloat(this.status.TotalDebet),
				credit: printHumanFloat(this.status.TotalCredit)
			};
		},
		openingBalanceParams():any {
			let ob = this.result ? this.result.OpeningBalance : null;
			if (!ob) return {};
			return {
				lines: ob.Lines,
				debet: printHumanFloat(ob.TotalDebet),
				credit: printHumanFloat(ob.TotalCredit),
				result: printHumanFloat(ob.ResultAmount),
				ledger: ob.ResultLedgerCode
			};
		}
	},
	methods: {
		printDate(date:Date):string {
			return printLocalDate(date);
		},
		printFloat(value:number):string {
			return printHumanFloat(value);
		},
		close() {
			this.$emit("close");
		},
		async loadStatus() {
			this.status = await FixedAssetService.getOpeningBalanceStatus(this.bookYear);
		},
		async run() {
			this.busy = true;
			try {
				this.result = await FixedAssetService.updateBookYear(this.bookYear, this.doDepreciations, this.doOpeningBalance);
				await this.loadStatus();
				this.$wf.notify(this.$ct("update-bookyear-done").toString(), "success", 3000, "check");
			} finally {
				this.busy = false;
			}
		},
		async deleteManualGroup(group:IManualOpeningGroup) {
			let confirm = await this.$confirmBuilder(this.$ct("delete-manual-group-warning", {group: group.GroupID})).setWarningTitle().show();
			if (!confirm) return;
			this.busy = true;
			try {
				await FixedAssetService.deleteManualOpeningGroup(this.bookYear, group.GroupID);
				await this.loadStatus();
			} finally {
				this.busy = false;
			}
		}
	},
	async mounted() {
		if (!this.hasPreviousBookYear) {
			this.doOpeningBalance = false;
		}
		await this.loadStatus();
	},
	i18nEx: {
		componentPrefix: "components.fixed-assets"
	}
});
